<template>
  <div class="switch">
    <span :class="{switch_choosed: captical==1}"
          @click="changeCapticalT()">{{selectObj[0]}}</span>
    <span :class="{switch_choosed: captical==2}"
          @click="changeCapticalF()">{{selectObj[1]}}</span>
    <span :class="{switch_choosed: captical==3}"
          v-show="selectObj[2]"
          @click="changeCapticalThree()">{{selectObj[2]}}</span>
  </div>
</template>

<script>
export default {
  props: ['selectarr', 'sWitch'],
  data: function() {
    return {
      captical: 1
      // selectObj: []
    };
  },
  mounted: function() {
    this.captical = this.sWitch;
    // this.selectObj = JSON.parse(this.selectarr);
    // this.selectarr = JSON.parse(this.selectarr)
    // console.log(this.selectarr, typeof this.selectarr)
  },
  computed: {
    selectObj: function() {
      return JSON.parse(this.selectarr);
    }
  },
  methods: {
    changeCapticalT: function() {
      this.captical = 1;
      this.$emit('update:sWitch', 1);
      // console.log('hello')
    },
    changeCapticalF: function() {
      this.captical = 2;
      this.$emit('update:sWitch', 2);
    },
    changeCapticalThree: function() {
      this.captical = 3;
      this.$emit('update:sWitch', 3);
    }
  },
  watch: {
    selectarr: function(val) {
      console.log('selectarr');
      this.selectObj = JSON.parse(val);
      if (document.body.clientWidth > 1366 && this.captical == 3) {
        this.captical = 2;
        this.$emit('update:sWitch', 2);
      }
    }
  }
};
</script>

<style>
.switch {
  /* display: inline; */
  overflow: hidden;
  /* width: 80px; */

  font-size: 0;
  cursor: pointer;
  border-radius: 2px;
  /* color: #fefefe; */
}

.switch span {
  display: inline-block;
  padding: 0 5px;
  font-size: 12px;
  color: #db1919;
  text-align: center;
  border: 1px solid #b91010;
}

.switch .switch_choosed {
  background: #b91010;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/card/cardSwitch.vue